import React from 'react'

const TierTable = ({ tierData, isProviderOnTierBonus,formatCurrency }) => {
     const tierRecords = tierData?.flat();
    const tierType = tierRecords && tierRecords.length > 0 ? tierRecords[0].tierType : null;
    const sortedTierData = tierData.map((practiceRecord)=>{
      return practiceRecord.sort((a, b) => {
          return a.amountFrom - b.amountFrom;
      })
    })

  return  <div className="content">
             <h5>{'Tier Bonus'}</h5>
             {sortedTierData.map((practiceValues, pVKey) => {

              const practiceTierRecordRows = practiceValues.map((practiceRecord, pRkey) => {
                   return (
                       <tr key={pVKey+"_"+pRkey}>
                           {pRkey ===0 && <td rowSpan={practiceValues.length}>{practiceRecord.practiceName}</td>}
                           <td>
                               {`${formatCurrency(practiceRecord.amountFrom)} - ${formatCurrency(practiceRecord.amountTo)} `}
                           </td>
                           {practiceRecord.tierType!==1&&<td>
                               {`${formatCurrency(practiceRecord.bracketValue)}`}
                           </td>}
                           <td>{(practiceRecord.percentValue)}%</td>
                           <td>{(practiceRecord.tierType===1&&practiceRecord.flagged) || (practiceRecord.tierType!==1)?formatCurrency(practiceRecord.bonusValue):formatCurrency(0)}</td>
                       </tr>
                   )
               })

                  const practiceTierRecordRowsTotal = practiceValues.reduce((acc, practiceRecord) => {
                        const total =  (practiceRecord.tierType===1&&practiceRecord.flagged) || (practiceRecord.tierType!==1)? acc + parseFloat(practiceRecord.bonusValue):acc+0
                         return total;
                     },0)

               return   <div key={"tiertab"+pVKey}>
                     <table className="table table-hover table-sm mt-0 mb-0">
                         <thead>
                         <tr>
                             <th> Practice</th>
                             <th> Range</th>
                             {tierType!==1&&<th> Range Value</th>}
                             <th> Percent</th>
                             <th> Bonus</th>
                            </tr>
                         </thead>
                         <tbody>
                         {isProviderOnTierBonus&&practiceTierRecordRows}
                         {isProviderOnTierBonus?<tr>
                             <td colSpan={tierType!==1?3:2}>Total</td>
                             <td>Total</td>
                             <td>{formatCurrency(practiceTierRecordRowsTotal)}</td>
                         </tr>:<tr>No Records Found</tr>}
                         </tbody>
                     </table>
                 </div>
             
             })
            }
            </div>
};

export default TierTable